import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType, ChartTimerName, ChartTimerStatus } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const NIVALIZ_TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.NIVALIZ_TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP,
    chartType: ChartRendererType.HEATMAP,
    endpoint: TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.NIVALIZ },
        {
            key: ChartQueryParam.NAME,
            value: [ChartTimerName.TRANSACTION_DROP_OFF_PENDING, ChartTimerName.TRANSACTION_PICK_UP_PENDING]
        },
        { key: ChartQueryParam.STATUS, value: ChartTimerStatus.COMPLETED },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.DAY }
    ]
};
